/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const markEmailsAsReadDataSchema = z.object({
	emailIds: z.array(z.string()).nullable().optional(),
})

export type MarkEmailsAsReadDataSchema = z.infer<typeof markEmailsAsReadDataSchema>
